<template>
  <div class="wrap">

    <!-- 视频内容 -->
    <div class="video-box">

      <!-- 直播回放 -->

      <video-room v-if="live && live.liveCourseStatus == 3" ref="videoRoom" :classId="classId"
        :course-id="live.courseId" :id="id" :show-id="id" />
      <!-- 伪直播 -->
      <!-- <live v-if=" isLive == 1 " ref="live"   :course-id="courseId"    /> -->
      <!-- 直播 -->
      <cc-live v-if="live && live.liveCourseStatus == 1" :course-id="live.courseId" :id="id" :show-id="id" />
    </div>

    <div v-if="genre != 3" class="content">
      <div class="tabTwo m-t-24">
        <div v-if="isLive != 1" class="tabTwo-text" :class="NavIndex == 1 ? 'active' : ''" @click="NavIndex = 1">
          课程答疑
          <div v-if="NavIndex == 1" class="on" />
        </div>
        <div class="tabTwo-text" :class="NavIndex == 2 ? 'active' : ''" @click="NavIndex = 2">
          课程评分
          <div v-if="NavIndex == 2" class="on" />
        </div>
      </div>
      <answer-view :IsPurchase="IsPurchase" v-if="NavIndex == 1" :type="1" :semester-id="semesterId" :status="1"
        :course-id="courseId" :chapter-id="id" :detail="live" />
      <score-evaluation :IsPurchase="IsPurchase" v-if="NavIndex == 2" :type-id="classId" />
    </div>
    <el-dialog title="提示" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="ifHave" width="30%" center>
      <span>尚未购买无法观看</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goBack">返回上一页</el-button>
        <el-button type="primary" @click="goOrder">去购买</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="ifEnd" width="30%" center>
      <span>试听结束</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goOrder">去购买</el-button>
      </span>
    </el-dialog>
    <!-- 全屏阴影块弹框 -->
    <div v-if="ifWatchingOther" class="watchOtherBg">
      <div class="watchOtherContent">
        <div class="watchOtherTitle">提示</div>
        <div class="watchOtherText">{{ watchingOtherMsg }}</div>
        <div class="watchOtherBtn" @click="goHome">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
// import { getLbClassCourseListById, getLbClassCourseById } from '@/api/home'
// import LiveRoom from '@/components/Know/liveRoom.vue'
import videoRoom from '@/components/Know/videoRoom.vue'
// import live from '@/components/Know/live.vue' 
import scoreEvaluation from '@/components/Know/course/scoreEvaluation.vue'
import answerView from '@/components/Know/course/answerView1.vue'
// import { OrderClient } from '@/api/orderClient'
// const orderClient = new OrderClient()
// import { getLbClassCourse } from '@/api/mykecheng'
import { getInfo, getDomain } from '@/api/cookies'
import ccLive from '@/components/Know/ccLive.vue'
// import kowledgePoints from '@/components/kowledgePoints.vue'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
import { LearningRateIO } from "@/utils/socketIO";
import { setUrlParams, getUrlParams, setStyleFixed, exitStyleFixed } from "@/utils/public";
let learningIO = null; // 学习率实例
export default {
  components: {
    scoreEvaluation,
    answerView,
    // LiveRoom,
    videoRoom,
    // live,
    ccLive,
    // kowledgePoints,
    // publicClassDetail,
    // videoRoomobs
  },
  data() {
    return {
      copyright: {},
      userInfo: {},
      NavIndex: 1,
      id: null,
      chapterName: null,
      classId: null,
      courseId: null,
      coursePackageId: null,
      detail: {},
      isLive: null,
      ccConfig: null,
      ccRomid: null,
      recordId: null,
      IsPurchase: true,
      isTrial: false,
      backAudition: 0,
      ifEnd: false,
      ifHave: false,
      ifWatchingOther: false,
      watchingOtherMsg: '',
      liveInfo: {},
      liveshowplaybackList: [],
      startTime: '',
      live: null,
      setIntervals: null,
      classProductLine: 0,
      status: 0,
      getExplorer: '',
      genre: null,
      aliVideoUrl: null,
      teacherId: null,
      isOpen: false,
      ccLiveid: null,
      timer: null,
      duration: null,
      typekc: null,
      semesterId: null,
      courseYear: null,
    }
  },
  async created() {
    this.userInfo = getInfo()
    this.copyright = getDomain()
    this.id = this.$route.query.id
    this.courseId = this.$route.query.courseId
    this.classId = this.$route.query.classId
    this.courseYear = this.$route.query.dateYear
    let res = await homeClient.getWatchStatusPC({
    })
    if (res.code == 0) {
      await this.getDetail()
    } else {
      this.watchingOtherMsg = res.msg || '您已在观看其他课程'
      this.ifWatchingOther = true
    }


  },
  beforeDestroy() {
    clearInterval(this.setIntervals)
  },
  methods: {
    trialEnd() {
      this.isTrial = false
      this.$confirm('试听结束', '提示', {
        confirmButtonText: '去购买',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.goOrder()
        })
        .catch(() => { })
    },
    goBack() {
      this.$router.go(-1)
    },
    goHome() {
      this.$router.push('/')
    },

    async getDetail() {

      await homeClient.getCourseDataLiveVo(
        {
          playId: this.id,
          teachingMethod: 1
        }
      ).then(async (res) => {
        this.live = res.data
        this.courseId = this.live.courseId

        if (this.classId && this.live.liveCourseStatus == 1) {
          const res = await homeClient.getNewestSemester({
            classTypeId: this.classId,
          });
          if (res.code == 0) {
            this.semesterId = res.data.id;

          }
          learningIO = new LearningRateIO({
            recordPars: {
              belongCourseTitleId: this.live.belongCourseTitle, // 课程名id
              chapterId: this.live.chapterId, // 章id
              classTypeId: this.classId, // 班型id
              courseId: this.live.courseId, // 课程id
              nodeId: "", // 节id
              pageLocationTypeCode: 3, // 1近期直播进入观看直播中 3辅导班型进入观看直播中 6学习记录进入观看直播中
              semesterId: this.semesterId, // 学期id
              teachingMethod: 1, // 1直播 2录播
            },
          });
          learningIO.connect(
            setUrlParams({
              userId: this.userInfo.userId,
              clientTypeCode: "PC",
              chapterId: this.live.chapterId, // 章id
              classId: this.classId, // 班型id
              courseId: this.live.courseId, // 课程id
              courseNameId: this.live.belongCourseTitle, // 课程名id
              dateYear: this.courseYear,
              nodeId: "",
              semesterId: this.semesterId, // 学期id
              videoTypeCode: 1, // 1直播 2录播 3小班课
            })
          );
          learningIO.$on("serverPingSend", () => {
            learningIO.pingSendStudyRecord({
              userId: this.userInfo.userId,
              classId: this.classId,
              dateYear: this.courseYear,
              courseId: this.live.courseId,
              chapterId: this.live.chapterId,
              nodeId: "",
              videoTypeCode: 1, // 1直播 2录播 3小班课
              currentSeeSec: 1,
              clientType: "PC",
              liveStartTime: this.live.liveStartTime,
              semesterId: this.semesterId,
              liveStatus: 1,
              courseNameId: this.live.belongCourseTitle,
            });
          });
        }

      })
      this.$forceUpdate()
    },
    setTimer() {
      if (
        !this.IsPurchase &&
        this.isLive == 3 &&
        this.isTrial &&
        this.backAudition > 0
      ) {
        this.timer = setInterval(() => {
          this.backAudition--
          if (this.backAudition == 0) {
            this.ifEnd = true
            clearInterval(this.timer)
          }
        }, 1000)
      }
    },
    goOrder() {
      if (this.userInfo) {
        orderClient
          .addOrders(
            this.courseId,
            this.userInfo && this.userInfo.userId,
            this.live.title,
            2,
            this.live.title,
            this.live.kind
          )
          .then((res) => {
            if (res.code == 0) {
              this.$router.push({
                name: '个人中心订单页',
                params: { orderNumber: res.msg }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
      } else {
        Vue.prototype.goLoginView(true)
      }
    },
    cutting() {
      const index = this.ccConfig.indexOf('?')
      if (index != -1) {
        const str = this.ccConfig.substr(index + 1)
        const strs = str.split('&')
        for (var i = 0; i < strs.length; i++) {
          this.liveInfo[strs[i].split('=')[0]] = strs[i].split('=')[1]
        }
      }
    },
    async getLbClassCourse() {
      if (!this.IsPurchase || !this.userInfo) {
        return
      }
      getLbClassCourse(
        1,
        this.userInfo && this.userInfo.userId,
        undefined,
        this.classId ? this.classId : undefined,
        this.id,
        undefined,
        this.courseId
      )
    },
    getIsOpen(isOpen, id) {
      this.isOpen = isOpen
      if (!isOpen) return
      this.$refs.kowledgePoints.getData(id)
    }
  }
}
</script>
<style lang="less" scoped>
.video-box {
  position: relative;

  #liveLog {
    position: absolute;
    right: 310px;
    bottom: 90px;
    z-index: 99999;

    img {
      height: 40px;
    }
  }

  #logo {
    position: absolute;
    right: calc(50% - 610px + 380px);
    bottom: 150px;
    z-index: 99999;

    img {
      height: 40px;
    }
  }
}

.wrap {
  width: 100%;
  height: 100%;
}

.wrap-play {
  height: 617px;
  background: #222222;
}

.content {
  width: 1220px;
  background: #ffffff;
  margin: 20px auto;

  .knowledge_points-box {
    width: 1220px;
    max-height: 580px;
    background-color: #ffffff;
    margin: 20px auto;
    padding: 32px 20px;
    overflow: auto;
  }
}

::v-deep .prism-setting-btn {
  display: none !important;
}

::v-deep .prism-cc-btn {
  display: none !important;
}

/* 全屏阴影块弹框样式 */
.watchOtherBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.watchOtherContent {
  width: 400px;
  background: #ffffff;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.watchOtherTitle {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
}

.watchOtherText {
  font-size: 16px;
  color: #666666;
  margin-bottom: 30px;
  line-height: 24px;
}

.watchOtherBtn {
  width: 120px;
  height: 40px;
  background: #409EFF;
  color: #ffffff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.watchOtherBtn:hover {
  background: #66b1ff;
}
</style>